import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  getSongBySlug,
  incrementPlay,
  toggleLikeSong,
  incrementShare,
} from "../services/songService";

import SongActions from "../../components/songs/SongActions";
import SongCommentsModal from "../../components/songs/SongCommentsModal";
import { getTrendingSongs, getUserHistory } from "../services/songService";
import { useNavigate } from "react-router-dom";

import "./SongDetails.css";

const SongDetails = () => {
  const { id } = useParams();

  const [song, setSong] = useState(null);
  const [loading, setLoading] = useState(true);

  const [liked, setLiked] = useState(false);
  const [likeCount, setLikeCount] = useState(0);
  const [shareCount, setShareCount] = useState(0);
  const [likeLoading, setLikeLoading] = useState(false);

  const [showComments, setShowComments] = useState(false);
  
  const [playlist, setPlaylist] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  const audioRef = useRef(null);
  const playStartRef = useRef(null);

  useEffect(() => {
    fetchSong();
  }, [id]);

useEffect(() => {
  fetchRecommended();
}, [id]);

  const fetchSong = async () => {
    try {
      const res = await getSongBySlug(id);

      if (res?.status) {
        const songData = res.song;

        setSong(songData);
        setTimeout(() => {
       audioRef.current?.play().catch(() => {});
       }, 300);

        setLikeCount(songData.totalLikes || 0);
        setShareCount(songData.totalShares || 0);
        setLiked(res.isLiked || false);
        
      }
    } catch (error) {
      console.error("Song fetch error:", error);
    } finally {
      setLoading(false);
    }
  };


const fetchRecommended = async () => {
  try {
    const historyRes = await getUserHistory();

    let list = [];

    if (historyRes?.songs?.length > 0) {
      list = historyRes.songs;
    } else {
      const trendingRes = await getTrendingSongs();
      list = trendingRes.songs || [];
    }

    setPlaylist(list);

    const index = list.findIndex((s) => s.slug === id);
    setCurrentIndex(index >= 0 ? index : 0);

  } catch (err) {
    console.error("Recommended error:", err);
  }
};


  const handlePlay = () => {
    playStartRef.current = Date.now();
  };

  const handlePause = async () => {
    if (!playStartRef.current || !song?._id) return;

    const duration = Math.floor(
      (Date.now() - playStartRef.current) / 1000
    );

    if (duration > 0) {
      try {
        await incrementPlay(song._id, duration);
      } catch (err) {
        console.error("Play tracking error:", err);
      }
    }

    playStartRef.current = null;
  };

  const handleLike = async () => {
  if (!song?._id || likeLoading) return;

  setLikeLoading(true);

  const previousLiked = liked;
  const previousCount = likeCount;

  const newLikedState = !previousLiked;

  // Optimistic update
  setLiked(newLikedState);
  setLikeCount(
    newLikedState
      ? previousCount + 1
      : Math.max(previousCount - 1, 0)
  );

  try {
    const res = await toggleLikeSong(song._id);

    if (res?.status === true) {
      if (typeof res.liked === "boolean") {
        setLiked(res.liked);
      }
    } else {
      // rollback
      setLiked(previousLiked);
      setLikeCount(previousCount);
    }

  } catch (error) {
    console.error("Like error:", error);

    // rollback
    setLiked(previousLiked);
    setLikeCount(previousCount);

  } finally {
    setLikeLoading(false);
  }
};



  /* ================= UPDATED SHARE ================= */

  const handleShare = async () => {
    if (!song?._id) return;

    const shareData = {
      title: song.title,
      text: `Listen to "${song.title}" on ShareVideo`,
      url: window.location.href,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(window.location.href);
        alert("Link copied!");
      }

      await incrementShare(song._id);
      setShareCount((prev) => prev + 1);

    } catch (err) {
      console.error("Share error:", err);
    }
  };

const handleNext = () => {
  if (!playlist.length) return;
   audioRef.current?.pause();

  const nextIndex = (currentIndex + 1) % playlist.length;
  const nextSong = playlist[nextIndex];

  navigate(`/song/${nextSong.slug}`);
};

const handlePrev = () => {
  if (!playlist.length) return;

  audioRef.current?.pause();
  const prevIndex =
    (currentIndex - 1 + playlist.length) % playlist.length;

  const prevSong = playlist[prevIndex];

  navigate(`/song/${prevSong.slug}`);
};




     const audioUrl = song?.audioUrl?.startsWith("http")
     ? song?.audioUrl
     : `https://${song?.audioUrl}`;

     const thumbnailUrl = song?.thumbnailUrl?.startsWith("http")
      ? song?.thumbnailUrl
       : `https://${song?.thumbnailUrl}`;

  useEffect(() => {
     if (!song || !thumbnailUrl) return;

  if ("mediaSession" in navigator) {
    navigator.mediaSession.metadata = new MediaMetadata({
      title: song.title || "Unknown",
      artist: song.channelName || "Artist",
      album: "ShareVideo",
      artwork: [
        { src: thumbnailUrl, sizes: "96x96", type: "image/png" },
        { src: thumbnailUrl, sizes: "192x192", type: "image/png" },
        { src: thumbnailUrl, sizes: "512x512", type: "image/png" },
      ],
    });
  }
}, [song, thumbnailUrl]);


     if (loading) return <p className="song-loading">Loading...</p>;
     if (!song) return <p className="song-loading">Song not found</p>;


  return (
    <div className="song-container">

      <div className="song-main-card">

        <div className="song-thumbnail">
          {song.thumbnailUrl && (
            <img
              src={song.thumbnailUrl}
              alt={song.title}
            />
          )}
        </div>

        <div className="song-info">

          <h1 className="song-title">{song.title}</h1>

          <p className="song-plays">
            {song.totalPlays || 0} plays
          </p>

          <audio
            key={audioUrl}
            ref={audioRef}
            src={audioUrl}
            controls
            className="song-audio"
            onPlay={handlePlay}
            onPause={handlePause}
            onEnded={() => {
            handlePause();
            handleNext();
            }}
          />
          
        <div className="player-controls">
        <button className="control-btn" onClick={handlePrev}>
         &#9198;
         </button>

         <button className="control-btn" onClick={handleNext}>
           &#9197;
        </button>
       </div>
          <SongActions
            liked={liked}
            likeCount={likeCount}
            commentCount={song.totalComments || 0}
            shareCount={shareCount}
            onLike={handleLike}
            onCommentClick={() => setShowComments(true)}
            onShare={handleShare}
            loadingLike={likeLoading}
          />
        </div>

      </div>

      {song.lyrics && (
        <div className="song-lyrics-card">
          <h3>Lyrics</h3>
          <div className="song-lyrics">
            {song.lyrics}
          </div>
        </div>
      )}

      {showComments && (
        <SongCommentsModal
          song={song}
          onClose={() => setShowComments(false)}
        />
      )}

    </div>
  );
};

export default SongDetails;